import styled, { css } from 'styled-components';

// Shared building blocks for the Agentic Commerce empty-state illustrations. Positions are the Figma frames'
// own, in px; colors are theme token names, so both illustrations follow the light and dark themes.

export function mix(p, token, percent) {
  return `color-mix(in srgb, ${p.theme.colors[token]} ${percent}%, transparent)`;
}

export const positioned = css`
  height: ${p => (p.$height === undefined ? 'auto' : `${p.$height}px`)};
  left: ${p => p.$left}px;
  position: absolute;
  top: ${p => p.$top}px;
  width: ${p => (p.$width === undefined ? 'auto' : `${p.$width}px`)};
`;

export const Tile = styled.div`
  ${positioned};
  background-color: ${p => p.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.gray300};
  border-radius: 12px;
  box-shadow: ${p => p.theme.boxShadow.medium};
  overflow: hidden;
`;

// $darkColor is for the few shapes whose dark-theme color in the design is a different token from the light one.
export const Bar = styled.div`
  ${positioned};
  background-color: ${p => p.theme.colors[p.$color]};
  border-radius: ${p => p.$radius ?? 0}px;

  ${p =>
    p.$darkColor &&
    css`
      :root[data-theme='dark'] & {
        background-color: ${p.theme.colors[p.$darkColor]};
      }
    `}
`;

export const Pill = styled(Bar).attrs(p => ({ $height: p.$height ?? 6, $radius: p.$radius ?? 3 }))``;

export const Dot = styled(Bar).attrs({ $height: 7, $radius: 4, $width: 7 })``;

export const Text = styled.span`
  color: ${p => p.theme.colors[p.$color ?? 'black']};
  font-size: ${p => p.$size}px;
  font-weight: ${p => p.theme.fontWeight[p.$weight ?? 'normal']};
  left: ${p => p.$left}px;
  line-height: normal;
  position: absolute;
  top: ${p => p.$top}px;
  white-space: nowrap;
`;

export const Arrow = styled(Text).attrs(p => ({ $color: 'green400', $size: p.$size ?? 9, $weight: 'mediumHeavy' }))``;
